<template>
     <div>
        <br/>
        <div>
            <base-checkbox class="mb-3" v-model="menus.override_color_id"><b>Color</b></base-checkbox>
        </div>
        <div style="padding-left: 35px;">
            <base-input >
                <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="menus.color_id" :disabled="menus.override_color_id != true">
                    <a-select-option v-for="option in colors" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
            </base-input>
        </div>

        <div style="padding-left: 35px;">
            <base-input label="Color Family">
                <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="menus.sub_color_id" :disabled="menus.override_color_id != true">
                    <a-select-option v-for="option in subcolors" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
            </base-input>
        </div>

     </div>
</template>

<script>

import HTTPRequest from '../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'

var component_x;
export default {
    components: {
        // draggable
    },
    data: function(){
            return {
                menus: {},
                colors: [],
                override_color_id: false,
                color_id: null,
                subcolors: [],
                sub_color_id: null,
                settingCode: null
            }
    },
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),
    },
    mounted: async function() {
        // console.log("***************")
        // console.log(this.$attrs.defaultValue)
        component_x = this;
        var colorRequest = await HTTPRequest.getRequest(this.endPoint + '/colors', null);
        this.colors = colorRequest.data
        this.settingCode = this.$attrs.settingCode
    },
    watch: {
        color_id: async function () {
                var subcolorReq = await HTTPRequest.getRequest(this.endPoint + '/color_family?color_id=' + this.menus.color_id, null);
                this.subcolors = subcolorReq.data;
        },
        menus: {
            handler: async function() {
                this.color_id = this.menus.color_id
                var configValues = {}
                configValues[this.settingCode] = this.menus
                component_x.$emit("changeValue", configValues)
            },
            deep: true
        }  
    },
    methods: {
        
    }
}
</script>

